(function () {
  'use strict';

  var storageKey = 'steng-color-mode';
  var allowedModes = ['system', 'light', 'dark'];
  var media = window.matchMedia('(prefers-color-scheme: dark)');

  function getMode() {
    var mode = document.documentElement.dataset.colorMode || 'system';
    try {
      var saved = localStorage.getItem(storageKey);
      if (allowedModes.indexOf(saved) !== -1) mode = saved;
    } catch (error) {}
    return allowedModes.indexOf(mode) !== -1 ? mode : 'system';
  }

  function resolveMode(mode) {
    return mode === 'system' ? (media.matches ? 'dark' : 'light') : mode;
  }

  function updateMetaThemeColor(resolvedMode) {
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', resolvedMode === 'dark' ? '#070909' : '#ffffff');
  }

  function syncControls(mode, resolvedMode) {
    document.querySelectorAll('[data-steng-theme-control]').forEach(function (control) {
      control.querySelectorAll('[data-steng-theme-option]').forEach(function (option) {
        var active = option.dataset.stengThemeOption === mode;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      control.querySelectorAll('[data-steng-theme-icon]').forEach(function (icon) {
        icon.toggleAttribute('hidden', icon.dataset.stengThemeIcon !== mode);
      });

      var current = control.querySelector('[data-steng-theme-current]');
      if (current) {
        var activeOption = control.querySelector('[data-steng-theme-option="' + mode + '"] span');
        current.textContent = activeOption ? activeOption.textContent : mode;
      }

      control.dataset.resolvedTheme = resolvedMode;
    });
  }

  function applyMode(mode, persist) {
    if (allowedModes.indexOf(mode) === -1) mode = 'system';
    var resolvedMode = resolveMode(mode);
    var root = document.documentElement;

    root.dataset.colorMode = mode;
    root.dataset.colorTheme = resolvedMode;
    root.style.colorScheme = resolvedMode;
    updateMetaThemeColor(resolvedMode);

    if (persist) {
      try { localStorage.setItem(storageKey, mode); } catch (error) {}
    }

    syncControls(mode, resolvedMode);
    document.dispatchEvent(new CustomEvent('steng:color-mode-change', {
      detail: { mode: mode, resolvedMode: resolvedMode }
    }));
  }

  function closeAll(except) {
    document.querySelectorAll('[data-steng-theme-control]').forEach(function (control) {
      if (control === except) return;
      var menu = control.querySelector('[data-steng-theme-menu]');
      var trigger = control.querySelector('[data-steng-theme-trigger]');
      if (menu) menu.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function bindControl(control) {
    if (control.dataset.stengThemeBound === 'true') return;
    control.dataset.stengThemeBound = 'true';

    var trigger = control.querySelector('[data-steng-theme-trigger]');
    var menu = control.querySelector('[data-steng-theme-menu]');
    if (!trigger || !menu) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var opening = menu.hidden;
      closeAll(control);
      menu.hidden = !opening;
      trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        var selected = menu.querySelector('[aria-checked="true"]');
        if (selected) selected.focus();
      }
    });

    menu.querySelectorAll('[data-steng-theme-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        applyMode(option.dataset.stengThemeOption, true);
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      });
    });

    menu.addEventListener('keydown', function (event) {
      var options = Array.prototype.slice.call(menu.querySelectorAll('[data-steng-theme-option]'));
      var index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        var direction = event.key === 'ArrowDown' ? 1 : -1;
        options[(index + direction + options.length) % options.length].focus();
      }
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-steng-theme-control]').forEach(bindControl);
    applyMode(getMode(), false);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-steng-theme-control]')) closeAll();
  });

  media.addEventListener('change', function () {
    if (getMode() === 'system') applyMode('system', false);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) applyMode(getMode(), false);
  });

  document.addEventListener('DOMContentLoaded', bindAll);
  document.addEventListener('shopify:section:load', bindAll);
  if (document.readyState !== 'loading') bindAll();
})();
